<template>
  <div class="filter-accordion-item" :class="{ 'is-expanded': isExpanded }">
    <!-- Accordion Header -->
    <button
      class="accordion-header"
      @click="handleToggle"
      @keydown.enter="handleToggle"
      @keydown.space.prevent="handleToggle"
      :aria-expanded="isExpanded"
      :aria-controls="`accordion-content-${filterType}`"
    >
      <div class="accordion-header-content">
        <theme-icon
          v-if="filterIcon"
          :icon="filterIcon"
          type="icons"
          classes="accordion-icon"
        />
        <span class="accordion-label">{{ filterLabel }}</span>
      </div>
      
      <svg
        class="accordion-chevron"
        :class="{ 'is-rotated': isExpanded }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>
    
    <!-- Accordion Content -->
    <transition name="accordion-slide">
      <div
        v-if="isExpanded"
        :id="`accordion-content-${filterType}`"
        class="accordion-content"
        role="region"
        :aria-labelledby="`accordion-header-${filterType}`"
      >
        <div class="accordion-content-inner">
          <slot :filter-data="filterData" :filter-type="filterType">
            <!-- Filter panel component will be inserted here -->
            <div class="default-content">
              <p>{{ filterLabel }} filter settings</p>
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FilterAccordionItem',
  
  props: {
    filterType: {
      type: String,
      required: true
    },
    filterLabel: {
      type: String,
      required: true
    },
    filterIcon: {
      type: String,
      default: 'filter'
    },
    filterData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    handleToggle() {
      this.$emit('toggle');
    },
    
    handleFilterUpdated(filterData) {
      this.$emit('filter-updated', filterData);
    }
  }
};
</script>
